import React from "react";
//Cookie token
import cookie from "react-cookies";
//Router redirect
import { useHistory } from "react-router-dom";

const Users = () => {
  //Redirect if not logged in
  let history = useHistory();
  const token = cookie.load("usertk");

  return (
    <>
      {!token ? (
        history.push("/")
      ) : (
        <>
          <h1>Nuevo Password</h1>
          <h1>Nuevo Password</h1>
          <h1>Nuevo Password</h1>
          <h1>Nuevo Password</h1>
          <h1>Nuevo Password</h1>
          <h1>Nuevo Password</h1>
          <h1>Nuevo Password</h1>
          <h1>Nuevo Password</h1>
          <h1>Nuevo Password</h1>
          <h1>Nuevo Password</h1>
          <h1>Nuevo Password</h1>
        </>
      )}
    </>
  );
};

export default Users;
